import {Component, Input} from '@angular/core';
import {Asset} from '../../shared/domain/item';
import {
  ASSET_ISSUE_DUPLICATED_SELLER_REF_ID,
  ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID
} from "../../shared/domain/item/asset-issue-type";

@Component({
  selector: 'lib-item-summary-item-issues',
  templateUrl: './item-issues.component.html',
  styleUrls: ['./item-issues.component.scss']
})
export class ItemIssuesComponent {
  @Input() asset: Asset;

  public isPotentialIssue(): boolean{
    let isPotentialIssuePresent = false;
    if(this.asset && this.asset.issues){
      this.asset.issues.forEach(issue => {
        if(issue.issueType === ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID || issue.issueType === ASSET_ISSUE_DUPLICATED_SELLER_REF_ID){
          isPotentialIssuePresent =  true;
        }

      })
    }
    return isPotentialIssuePresent;
  }

  public isMajorIssue(): boolean{
    let isMajorIssuePresent = false;
    if(this.asset && this.asset.issues){
      this.asset.issues.forEach(issue => {
        if(issue.issueType !== ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID && issue.issueType !== ASSET_ISSUE_DUPLICATED_SELLER_REF_ID){
          isMajorIssuePresent =  true;
        }

      })
    }
    return isMajorIssuePresent;
  }
}
